<template>
<v-row style="font-size:14px" align="center">
  <v-col cols="2">
    <v-btn small icon @click="show_more=!show_more">
      <v-icon small v-if="show_more">fa-minus</v-icon>
      <v-icon small v-else>fa-chevron-down</v-icon>
    </v-btn>
  </v-col>
  <v-col cols="4">
    {{invoice.date_added}}
  </v-col>
  <v-col cols="3">
    <span :class="`${invoice.status===0 ? 'blue' : 'green'}--text`">{{invoice.status === 0 ? 'Pending' : "Paid" }}</span>
  </v-col>
  <v-col cols="3" class="text-right">
    ${{invoice.display_amount}}
  </v-col>
  <v-col cols="12" class="pa-0" style="">
    <v-expand-transition>
      <div class="secondary lighten-1 white--text" v-if="show_more">
        <v-container class="">


          <v-row class="primary--text  text--lighten-1 caption" v-if="invoice.projects.length">
            <v-col cols="12">
              <span>Publishing</span>
            </v-col>
          </v-row>
          <v-divider dark v-if="invoice.projects.length"></v-divider>
          <v-row v-for="(project,p) in invoice.projects" :key="'p'+p" align="end">
            <v-col cols="9" class="py-1">
              <router-link class="nolink white--text" :to="`/project/${project.id}/${project.slug}`">
                <span>{{project.title}}</span>
              </router-link>
            </v-col>
            <v-col cols="3" class="text-right py-1">
                <span>${{project.report.display_amount_earned}}</span>
            </v-col>
            <v-col cols="9" class="py-0 pl-4" v-if="project.report.display_bonus>0">
               <span class="green--text">+ Contest bonus</span>
            </v-col>
            <v-col cols="3"  class="text-right py-0" v-if="project.report.display_bonus>0">
              <span>${{project.report.display_bonus}}</span>
            </v-col>
          </v-row>



          <v-row class="primary--text text--lighten-1 caption" v-if="project_support.length">
            <v-col cols="12">
              <span>Project Support</span>
            </v-col>
          </v-row>
          <v-divider dark v-if="project_support.length"></v-divider>
          <v-row v-for="(support,s) in project_support" :key="'ps'+s" align="end">
            <v-col cols="9">
              <span v-if="support.project"><router-link class="nolink white--text" :to="`/project/${support.project.id}/${support.project.slug}`">{{support.project.title}}</router-link><br /></span>
              <span v-if="support.message" class="caption">
                <v-icon dark class="mr-1" color="grey" style="font-size:8px;margin-top:-8px">fa-quote-left</v-icon>
                {{support.message}}
                <v-icon dark class="ml-1"  color="grey"  style="font-size:8px;margin-top:-8px">fa-quote-right</v-icon>
              </span>
              <span v-else class="caption">
                Anonymous
              </span>
            </v-col>
            <v-col cols="3" class="text-right">
              <span>${{support.display_amount_earned}}</span>
            </v-col>
          </v-row>


          <v-row class="primary--text text--lighten-1 caption" v-if="profile_support.length">
            <v-col cols="9">
              <span>Profile Support</span>
            </v-col>
            <v-col cols="3" class="text-right">
            </v-col>
          </v-row>
          <v-divider dark v-if="profile_support.length"></v-divider>
          <v-row v-for="(support,s) in profile_support" :key="'s'+s" align="end">
            <v-col cols="9">
              <span v-if="support.project"><router-link class="nolink white--text" :to="`/project/${support.project.id}/${support.project.slug}`">{{support.project.title}}</router-link><br /></span>
              <span v-if="support.message" class="caption">
                <v-icon dark class="mr-1" color="grey" style="font-size:8px;margin-top:-8px">fa-quote-left</v-icon>
                {{support.message}}
                <v-icon dark class="ml-1"  color="grey"  style="font-size:8px;margin-top:-8px">fa-quote-right</v-icon>
              </span>
              <span v-else class="caption">
                Anonymous
              </span>
            </v-col>
            <v-col cols="3" class="text-right">
              <span>${{support.display_amount_earned}}</span>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-expand-transition>
  </v-col>
</v-row>
</template>
<script>
export default {
  props: ['invoice'],
  name: "",
  data: () => ({
    show_more: false
  }),
  computed: {
    profile_support() {
      return this.invoice.support.filter(s => {
        return !s.project
      })
    },
    project_support() {
      return this.invoice.support.filter(s => {
        return s.project
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
